import React from "react";
import ReporteFinancieroVentas from "../components/ReporteFinancieroVentas";

const InformeFinancieroVentas = () => {
  return (
    <>
      <ReporteFinancieroVentas />
    </>
  );
};

export default InformeFinancieroVentas;